<template>
  <transition
    name="slide"
    mode="out-in"
    :enter-active-class="$style['slide--enter-active']"
    :leave-active-class="$style['slide--leave-active']"
    :enter-from-class="$style['slide--enter-from']"
    :leave-to-class="$style['slide--leave-to']"
    @after-leave="$emit('afterLeave')"
  >
    <!-- eslint-disable vue/require-toggle-inside-transition -->
    <slot />
  </transition>
</template>

<script lang="ts" setup>
defineEmits<{
  (event: 'afterLeave'): void
}>()
</script>

<style lang="scss" module>
.slide {
  $time: $transition-base;

  // stylelint-disable selector-class-pattern
  &--enter-active,
  &--leave-active {
    transform: translate(0, 0);
    transition:
      opacity $time,
      transform $time;
  }

  &--enter-from,
  &--leave-to {
    opacity: 0;
    transform: translate(0, -4%);
  }
  // stylelint-enable selector-class-pattern
}
</style>
